import Icon from '@/components/ui/AppIcon';

interface AuditTimelineItemProps {
  date: string;
  auditType: string;
  auditor: string;
  result: 'passed' | 'minor' | 'major';
  findings: number;
  corrective: number;
  isLast?: boolean;
}

export default function AuditTimelineItem({
  date,
  auditType,
  auditor,
  result,
  findings,
  corrective,
  isLast = false
}: AuditTimelineItemProps) {
  const resultConfig = {
    passed: { 
      color: 'bg-success text-success-foreground', 
      icon: 'CheckCircleIcon',
      label: 'Passed' 
    },
    minor: { 
      color: 'bg-warning text-warning-foreground', 
      icon: 'ExclamationTriangleIcon',
      label: 'Minor Findings' 
    },
    major: { 
      color: 'bg-error text-error-foreground', 
      icon: 'XCircleIcon',
      label: 'Major Findings' 
    }
  };

  return (
    <div className="relative flex items-start space-x-4 pb-8">
      {!isLast && (
        <div className="absolute left-5 top-12 w-0.5 h-full bg-border"></div>
      )}
      
      <div className={`flex-shrink-0 w-10 h-10 rounded-full ${resultConfig[result].color} flex items-center justify-center z-10`}>
        <Icon name={resultConfig[result].icon as any} size={20} variant="solid" />
      </div>
      
      <div className="flex-1 bg-card rounded-lg border border-border p-4 hover:shadow-md transition-all duration-base">
        <div className="flex items-start justify-between mb-3">
          <div>
            <h4 className="text-base font-headline font-bold text-foreground">{auditType}</h4>
            <p className="text-sm font-body text-muted-foreground">{date}</p>
          </div>
          <span className={`px-3 py-1 rounded-md text-xs font-cta font-bold ${resultConfig[result].color}`}>
            {resultConfig[result].label}
          </span>
        </div>
        
        <div className="space-y-2">
          <div className="flex items-center space-x-2">
            <Icon name="UserCircleIcon" size={16} variant="outline" className="text-primary" />
            <p className="text-sm font-body text-foreground">
              <span className="font-semibold">Auditor:</span> {auditor}
            </p>
          </div>
          
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-2">
              <Icon name="DocumentMagnifyingGlassIcon" size={16} variant="outline" className="text-primary" />
              <p className="text-sm font-body text-foreground">
                <span className="font-semibold">{findings}</span> Findings
              </p>
            </div>
            
            <div className="flex items-center space-x-2">
              <Icon name="WrenchScrewdriverIcon" size={16} variant="outline" className="text-primary" />
              <p className="text-sm font-body text-foreground">
                <span className="font-semibold">{corrective}</span> Corrective Actions
              </p>
            </div>
          </div>
        </div>
        
        <button className="mt-3 text-sm font-cta font-semibold text-primary hover:text-primary/80 transition-all duration-base flex items-center space-x-1">
          <span>View Full Report</span>
          <Icon name="ArrowRightIcon" size={16} variant="outline" />
        </button>
      </div>
    </div>
  );
}